module.exports = __webpack_public_path__ + "img/round-bg-light-active.6ab35f0f.png";